import { render, staticRenderFns } from "./EquipmentListCard.vue?vue&type=template&id=c06254f2&scoped=true&"
import script from "./EquipmentListCard.vue?vue&type=script&lang=ts&"
export * from "./EquipmentListCard.vue?vue&type=script&lang=ts&"
import style0 from "./EquipmentListCard.vue?vue&type=style&index=0&id=c06254f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06254f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
